import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";
import {
  VOID_CONFIRM_MESSAGE,
  VOID_STATUS_FIELD,
} from "../utils/voidTransactionConfig";

export const screen_113_parts_issue: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: {
      type: "add",
      screenId: "120",
      action: "modulev1/parts_issue",
    },
    title: "Parts issue",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "spare_issue_no",
            Name: "parts_issue_summary",
            SummeryActions: [
              {
                ActionType: ActionType.VIEW_REPORT,
                Action: {
                  Action: "Report",
                  Api: "parts_issue_view",
                },
                tooltip: "View Report",
              },
              {
                Action: {
                  Action: "Navigate",
                  Navigate: "modulev1/parts_issue/<id>",
                },
                ActionType: "Edit",
                ScreenId: "120",
                hiddenWhenVoid: true,
              },
                            {
                ActionType: ActionType.VOID,
                permissionKey: "Void",
                confirmMessage: VOID_CONFIRM_MESSAGE,
                requireVoidReason: true,
                hiddenWhenVoid: true,
                visibleWhenNotDraft: true,
                voidReasonLabel: "Void Reason",
                tooltip: "Void",
                Action: {
                  Module: "parts_issue",
                  TransactionNoField: "spare_issue_no",
                },
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "parts_issue_from_store",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "parts_issue_summary",
              TableName: "",
              View: "view_parts_issue_summary",
              DisplayName: "Parts issue",
              Query:
                "SELECT view_parts_issue_summary.*, service_spare_part_issue.is_void, CASE WHEN COALESCE(service_spare_part_issue.is_void, 0) = 1 THEN 'Void' ELSE '' END AS status FROM view_parts_issue_summary LEFT JOIN service_spare_part_issue ON service_spare_part_issue.id = view_parts_issue_summary.id",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                VOID_STATUS_FIELD,
                {
                  IncludeLabel: true,
                  Label: "Issue No.",
                  BindValue: "issue_no",
                  Json_Attribute: "spare_issue_no",
                  componentType: ComponentType.TEXT_FIELD,
                  AutoPopulate_format: "SIN_[******]",
                  showInSummary: true,
                } as any,
                {
                  IncludeLabel: true,
                  Label: "Issue date",
                  BindValue: "issue_date",
                  Json_Attribute: "issue_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Jobcard No.",
                  BindValue: "jobcard_no",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Job date",
                  BindValue: "job_date",
                  Json_Attribute: "job_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VIN No.",
                  BindValue: "vin_no",
                  Json_Attribute: "vin_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
